import React, { useState, useEffect } from 'react';
import { LogoSVG, WhatsAppIconSmall, LockIcon } from '../Icons';
import { WA_NUMBER, WA_DEFAULT_MSG } from '../../data/constants';
import { waLink } from '../../utils/whatsapp';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const abrirEquipo = () => {
    window.open('https://svabogadas.tabularis.cl/', '_blank', 'noopener');
  };

  const abrirAsistente = () => {
    window.open(window.location.origin + '/asistente', '_blank');
  };

  return (
    <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
      <div className="nav-top">
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
          <a href="#hero" className="nav-logo">
            <LogoSVG />
            <div className="logo-text">
              <span className="logo-name">Souza &amp; Villa</span>
              <span className="logo-tagline">Abogadas</span>
            </div>
          </a>
          <div className="nav-eyebrow">Estudio Jurídico · Concepción</div>
        </div>
        <div className="nav-actions">
          <a href={waLink(WA_DEFAULT_MSG)} target="_blank" rel="noopener noreferrer" className="btn-nav-wa">
            <WhatsAppIconSmall /> <span className="btn-label">WhatsApp</span>
          </a>
          <button onClick={abrirEquipo} className="btn-nav-equipo">
            <LockIcon /> <span className="btn-label">Acceso Equipo</span>
          </button>
          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menú">
            <span /><span /><span />
          </button>
        </div>
      </div>
      <div className={`nav-bottom ${menuOpen ? 'open' : ''}`}>
        <ul className="nav-links">
          <li><a href="#socias" onClick={closeMenu}>Equipo</a></li>          
          <li><a href="#areas" onClick={closeMenu}>Áreas</a></li>
          <li><a href="#agendar" onClick={closeMenu}>Agendar</a></li>
          <li><a href="#servicios" onClick={closeMenu}>Servicios</a></li>
          <li><a href="#finiquito" onClick={closeMenu}>Calcular finiquito</a></li>
          <li><a href="#estado" onClick={closeMenu}>Soy Cliente</a></li>
          <li className="nav-has-dropdown">
            <button className="nav-link-btn">Más <span className="nav-chevron">▼</span></button>
            <div className="nav-dropdown">
              <a href="#faq" onClick={closeMenu}>Preguntas frecuentes</a>
              <a href="#oficinas" onClick={closeMenu}>Nuestras oficinas</a>
              <a href="#trabaja" onClick={closeMenu}>Trabaja con nosotros</a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
